const pre = 'homepage';

export default [{
    path: '/homepage',
    name: `${pre}`,
    meta: {
        title: '主页'
    },
    component: () =>
        import ('@/views/homepage')
}]